(function($) {
    require("selectize");
    $(".select-exchange").selectize({
        allowEmptyOption: true
    });
})(jQuery);
